import { render, staticRenderFns } from "./ExerciseForm.vue?vue&type=template&id=2e400520&scoped=true&"
import script from "./ExerciseForm.vue?vue&type=script&lang=js&"
export * from "./ExerciseForm.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseForm.vue?vue&type=style&index=0&id=2e400520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e400520",
  null
  
)

export default component.exports